<form class="personal-data-container component-container" [formGroup]="companyDataFG">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
    <div
      *ngIf="!(companyDataFG.controls.bdewId && companyDataFG.controls.bdewId.value !== '')"
      class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
      <label class="ui-g-7 field-label text-right-align" for="tax-id">{{ 'personal-data.form-details.fields.tax-id' | translate }}</label>
      <input
        class="ui-input pInputText small-width"
        formControlName="taxId"
        id="tax-id"
        maxlength="25"
        pInputText
        size="30"
        type="text"
        [readonly]="isReadOnly" />
    </div>

    <div
      *ngIf="companyDataFG.controls.bdewId && companyDataFG.controls.bdewId.value !== ''"
      class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
      <label class="ui-g-7 field-label text-right-align" for="bdew-id">{{ 'personal-data.form-details.fields.bdew-id' | translate }}</label>
      <input
        class="ui-input pInputText small-width"
        formControlName="bdewId"
        id="bdew-id"
        maxlength="25"
        pInputText
        size="30"
        type="text" />
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
      <label class="ui-g-7 field-label text-right-align" for="company-name">
        {{ 'personal-data.form-details.fields.company-name' | translate }}
      </label>
      <input
        class="ui-input pInputText small-width"
        formControlName="companyName"
        id="company-name"
        maxlength="25"
        pInputText
        size="30"
        type="text"
        [readonly]="isReadOnly" />
    </div>

    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding small-field-rows">
      <label class="ui-g-7 field-label text-right-align" for="telephone-number">
        {{ 'personal-data.form-details.fields.telephone-number' | translate }}
      </label>
      <input
        class="ui-input pInputText small-width"
        formControlName="telephoneNumber"
        id="telephone-number"
        maxlength="25"
        pInputText
        size="30"
        [readonly]="isReadOnly" />
    </div>
  </div>
</form>
